import extendedFieldHooks from "ExtendedFields/selectorHooks";

import FnrDivider from "UI/FnrDivider/FnrDivider";
import FnrLabeledIcon from "UI/FnrLabeledIcon/FnrLabeledIcon";

import ItemContainer from "../FieldDragList/ItemContainer";

const OtherGroupList = () => {
  const otherGroupFields = extendedFieldHooks.useOtherGroupFields();
  const [fieldId, setFieldId] = extendedFieldHooks.useSelectedFieldId();
  const signupVariant = extendedFieldHooks.useVariant() === "signupVariant";

  const handleClick = (id) => {
    setFieldId(id);
  };

  return (
    <>
      {Boolean(otherGroupFields.length) && <FnrDivider />}
      {otherGroupFields.map(({ id, children, icon }) => {
        const selected = fieldId === id;

        return (
          <ItemContainer
            $selected={selected}
            $disabled
            key={id}
            data-cy="FieldOtherGroupItem_ItemContainer"
            onClick={() => handleClick(id)}
            isSignupVariant={signupVariant}
          >
            <FnrLabeledIcon
              icon={icon}
              variant={selected ? "small" : "disabled"}
              data-cy="FieldOtherGroupItem_LabeledIcon"
            >
              {children}
            </FnrLabeledIcon>
          </ItemContainer>
        );
      })}
    </>
  );
};

export default OtherGroupList;
